import {Injectable} from "@angular/core";
import {StoredPaymentMethodRepository} from "@app/core/stored-payment-method/domain/stored-payment-method-repository";
import {
    DeleteStoredPaymentMethodWebService
} from "@app/core/stored-payment-method/infrastructure/delete-stored-payment-method-web-service";
import {catchError, Observable} from "rxjs";
import {BaseHandleErrorMapper} from "@app/core/shared/infrastructure/base.handler/base-handle-error.mapper";

@Injectable()
export class StoredPaymentMethodDataRepository implements StoredPaymentMethodRepository {
    constructor(
        private deleteStoredPaymentMethodWebService: DeleteStoredPaymentMethodWebService,
    ) {}

    delete(storedPaymentMethodId: string): Observable<void> {
        return this.deleteStoredPaymentMethodWebService.execute(storedPaymentMethodId).pipe(
            catchError(error => BaseHandleErrorMapper.handleError(error)),
        );
    }

}